import React, { useState } from 'react';
import { Divider, Menu, Typography } from 'antd';
import { Link, Icon } from '@common/components';

type OrganizationFacilityMenuItemType = {
  key: string;
  label: string;
  route: string;
};

type OrganizationFacilityMenuProps = {
  facilityId: string;
  facilityName: string;
  page: string;
};

export function OrganizationFacilityMenu({
  facilityId,
  facilityName,
  page,
}: OrganizationFacilityMenuProps) {
  const [activeMenu, setActiveMenu] = useState(page);

  const organizationFacilityMenuItems: {
    [key: string]: OrganizationFacilityMenuItemType;
  } = {
    details: {
      key: 'details',
      label: 'Details',
      route: `/works/admin/organization-structure/facility/${facilityId}/details`,
    },
    groups: {
      key: 'groups',
      label: 'Groups',
      route: `/works/admin/organization-structure/facility/${facilityId}/groups`,
    },
  };

  return (
    <>
      <section className="organization-facility__menu">
        <div className="organization-facility__menu__facility-name">
          <Typography.Title level={2}>{facilityName}</Typography.Title>
        </div>
        <Divider />
        <Menu
          className="organization-facility__menu__content"
          mode="vertical"
          defaultSelectedKeys={[organizationFacilityMenuItems.details.key]}
          selectedKeys={[activeMenu]}
          onSelect={(e) => setActiveMenu(e.key)}
        >
          {Object.keys(organizationFacilityMenuItems).map((item) => {
            return (
              <Menu.Item
                className="organization-facility__menu__item"
                key={organizationFacilityMenuItems[item].key}
              >
                <Link
                  className="organization-facility__menu__item-link"
                  to={organizationFacilityMenuItems[item].route}
                >
                  {organizationFacilityMenuItems[item].label}
                  <Icon icon="angleRight" kind="light" />
                </Link>
              </Menu.Item>
            );
          })}
        </Menu>
      </section>
      <style jsx>{`
        .organization-facility__menu {
          border-radius: 8px;
          padding: 24px;
          box-shadow: 0 4px 8px 0 rgba(36, 35, 41, 0.08);
        }

        .organization-facility__menu__facility-name :global(.ant-typography) {
          margin: 0;
        }

        .organization-facility__menu__item-link {
          font-size: 16px;
          line-height: 20px;
        }
      `}</style>
    </>
  );
}
